// Pozadie za každou obrazovkou appky: statický prechod z tokenov vzhľadu
// (--ww-backdrop v styles/tokens.css), vo vzhľade Ateliér aj jemné zrno.
//
// Kedysi to boli tri farebné polia, ktoré sa najprv samé vlnili na
// nekonečných CSS animáciách a potom sa posúvali za kurzorom. Prvé držalo
// nainštalovanú appku na Macu na ~40 % CPU/GPU, aj keď sa jej nikto nedotkol;
// druhé stále prekresľovalo tri vrstvy veľké ako obrazovka pri každom pohybe
// myši. Obsah pritom pozadie z väčšej časti zakrýva kartami, takže pohyb
// nebolo skoro vidieť — iba cítiť na batérii. Teraz sa obraz nakreslí raz.
//
// Zámerne bez filter: blur() a bez backdrop-filter: obe robia fixnú vrstvu
// drahou pri posúvaní v iOS Safari (rovnaký dôvod ako pri .tabbar).
export const LiveBackground = () => <div aria-hidden="true" className="ambient" />;
